import { useCollection } from "@tatsuokaniwa/swr-firestore";

export const useAreas = () => {
    const { data, ...rest } = useCollection<{ name: string }>({
        path: "areas",
    });

    const areas = data ?? [];

    return {
        areasAsList: areas,
        areas: areas.reduce<Record<string, string>>(function (map, obj) {
            map[obj.id] = obj.name;
            return map;
        }, {}),
        ...rest,
    };
};
